import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, func, shape, string,
} from 'prop-types'

import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

function SortDropdown({ value = '', options = EMPTY_ARRAY, onChange = NOOP }) {
  const selectedName = useMemo(() => {
    const selected = options.find(option => option.value === value)
    return selected ? selected.name : ''
  }, [options, value])

  const filtersConfig = useMemo(() => [{
    label: null,
    filters: options.map(({ name, value: optionValue }) => ({ value: optionValue, label: name })),
  }], [options])

  const selectedFilters = useMemo(() => [value], [value])

  const handleSortChange = useCallback((_, nextValue) => {
    onChange(nextValue)
  }, [onChange])

  const content = useMemo(() => (
    <FiltersSidebar
      isCollapsible={false}
      filters={filtersConfig}
      selectedFilters={selectedFilters}
      onFiltersChange={handleSortChange}
      isControlled
      hideLastDivider
      hideShowMore
      baseFormWrapperClassName="filter-wrapper__content"
      useNewCheckboxes
      useRadio
    />
  ), [filtersConfig, selectedFilters, handleSortChange])

  return (
    <FiltersWrapper
      placeholder={selectedName}
      content={content}
      positionHorizontal="left"
      closingDropdownClassName="filter-wrapper filter-sort-dropdown"
      size="medium"
    />
  )
}

SortDropdown.propTypes = {
  value: string,
  options: arrayOf(shape({
    name: string.isRequired,
    value: string.isRequired,
  })),
  onChange: func,
}

export default memo(SortDropdown)
